import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import FirebaseSyncPlugin from './plugins/FirebaseSyncPlugin'
import howler from './modules/howler'

Vue.use(Vuex);

const store = new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
	plugins: [FirebaseSyncPlugin()],
	modules: {
		howler
	}
})

export default store